exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prebuild-stars[data-v-4975a00e] {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 30px;\n}\n.prebuild-stars__review-count[data-v-4975a00e] {\n  color: #141226;\n  font-size: 14px;\n  letter-spacing: 0;\n  text-decoration: underline;\n  margin-left: 5px;\n  cursor: pointer;\n}", ""]);

// exports
